import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';

import { useIsWithinLinkedin } from '../../../hooks/useIsWithinLinkedin';

import { StyledNoDataContainer, StyledNoDataSubtitle, StyledNoDataTitle } from './styles';

export enum NoDataViewVariant {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  monthlyVisits = 'monthlyVisits',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  trafficShare = 'trafficShare',
}

export const NoDataView = ({ variant }: { variant: NoDataViewVariant }) => {
  const { t } = useTranslation();
  const isWithinLinkedin = useIsWithinLinkedin();

  const subtitleKey = isWithinLinkedin ? 'company.no_data.subtitle.linkedin' : 'company.no_data.subtitle';

  return (
    <StyledNoDataContainer variant={variant} data-automation="NoDataContainer">
      <SWReactIcons iconName="no-data-lab" variant={variant} size="132px" data-automation="NoDataIcon" />
      <StyledNoDataTitle data-automation="NoDataTitle">{t('company.no_data.title')}</StyledNoDataTitle>
      <StyledNoDataSubtitle data-automation="NoDataSubtitle">{t(subtitleKey)}</StyledNoDataSubtitle>
    </StyledNoDataContainer>
  );
};
